(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("FacilityDetailsViewModel", facilityDetailsViewModelFactory);

  /** @ngInject */
  function facilityDetailsViewModelFactory(
    invariant,
    modelUtils,
    moment,
    messagesStore,
    facilityUtils,
    washBoxUtils,
    FacilityDetailsWasBoxViewModel,
    FacilityDetailsListenerViewModel,
    FacilityDetailsListenerWashBoxViewModel,
    FacilityDetailsWashFacilityViewModel,
    FacilityDetailsTapWaterViewModel,
    FacilityDetailsSoftenedWaterViewModel,
    FacilityDetailsDemiWaterViewModel,
    FacilityDetailsReverseOsmosisViewModel,
    FacilityDetailsDoserViewModel
  ) {
    function FacilityDetailsViewModel(deviceJson) {
      this._devicesStoreChangeHandler = null;
      this._messagesStoreChangeHandler = null;

      this.deviceSerial = deviceJson.deviceKey;
      this.messages = [];
      this.alarmsCount = 0;
      this.warningsCount = 0;

      this.facility = {};
      this.tapWaterSubsystemData = {};
      this.softenedWaterSubsystemData = {};
      this.demiWaterSubsystemData = {};
      this.reverseOsmosisSubsystemData = {};
      this.doserSubsystemData = {};
      this.boxes = [];
      this.smallMachines = [];
      this.smallMachinesWashBoxes = [];

      init.call(this);
      refreshDeviceData.call(this, deviceJson);
    }

    FacilityDetailsViewModel.prototype.destroy = function() {
      messagesStore.off(
        messagesStore.events.CHANGE,
        this._messagesStoreChangeHandler
      );
    };

    FacilityDetailsViewModel.prototype.refreshFeed = function(payload) {
      var ids = payload.path.split("/");

      this.smallMachines = updateConnectionStatus(
        ids[2],
        payload.data,
        this.smallMachines
      );

      this.smallMachinesWashBoxes = updateConnectionStatus(
        ids[2],
        payload.data,
        this.smallMachinesWashBoxes
      );

      if (ids && ids.length > 0 && ids[0] === this.deviceSerial) {
        var feed = payload.data,
          subsystem = getSubsystem.call(this, ids);

        if (subsystem !== null && subsystem.refreshFeed) {
          subsystem.refreshFeed(feed);
        }
      }
    };

    FacilityDetailsViewModel.prototype.refreshState = function(payload) {
      this.status = payload.state;
      this.lastReportTimestamp = moment(payload.lastReportTimestamp).fromNow();
    };

    FacilityDetailsViewModel.prototype.refreshActuator = function(payload) {
      var ids = payload.path.split("/");

      this.smallMachines = updateConnectionStatus(
        ids[2],
        payload.data,
        this.smallMachines
      );

      this.smallMachinesWashBoxes = updateConnectionStatus(
        ids[2],
        payload.data,
        this.smallMachinesWashBoxes
      );

      if (ids && ids.length > 0 && ids[0] === this.deviceSerial) {
        var feed = payload.data,
          subsystem = getSubsystem.call(this, ids);

        if (subsystem !== null && subsystem.refreshActuator) {
          subsystem.refreshActuator(feed);
        }
      }
    };

    return FacilityDetailsViewModel;

    function init() {
      var that = this;

      refreshAlarms.call(that);
      this._messagesStoreChangeHandler = function() {
        refreshAlarms.call(that);
      };
      messagesStore.on(
        messagesStore.events.CHANGE,
        this._messagesStoreChangeHandler
      );
    }

    function refreshDeviceData(deviceJson) {
      var facilityPoint = null,
        washBoxPoints = null,
        smallMachinesPoints = null,
        smallMachinesWashBoxPoints = null;

      if (deviceJson === null) {
        return;
      }

      // ---------------------------------------------------------
      facilityPoint = facilityUtils.getFacilityPoint(deviceJson); // Return point (with actuators, feeds and points) from detail view
      washBoxPoints = washBoxUtils.getWashBoxPoints(facilityPoint);
      smallMachinesPoints = washBoxUtils.getListenerPoints(facilityPoint);
      smallMachinesWashBoxPoints = washBoxUtils.getListenerWashBoxPoints(
        facilityPoint
      );

      invariant(
        deviceJson && facilityPoint,
        "FacilityDetailsViewModel: could not fetch details data for device serial " +
          this.deviceSerial
      );

      this.status = deviceJson.state;
      this.lastReportTimestamp = moment(
        deviceJson.lastReportTimestamp
      ).fromNow();

      this.facility = new FacilityDetailsWashFacilityViewModel(facilityPoint);

      if (
        facilityPoint.deviceType !== "SERIAL_485" &&
        facilityPoint.deviceType !== "HHANLE"
      ) {
        this.tapWaterSubsystemData = new FacilityDetailsTapWaterViewModel(
          facilityPoint
        );
        this.softenedWaterSubsystemData = new FacilityDetailsSoftenedWaterViewModel(
          facilityPoint
        );
        this.demiWaterSubsystemData = new FacilityDetailsDemiWaterViewModel(
          facilityPoint
        );
        this.reverseOsmosisSubsystemData = new FacilityDetailsReverseOsmosisViewModel(
          facilityPoint
        );
        this.doserSubsystemData = new FacilityDetailsDoserViewModel(
          facilityPoint
        );
      }

      washBoxPoints.forEach(function(washBoxJson) {
        this.push(new FacilityDetailsWasBoxViewModel(washBoxJson));
      }, this.boxes);

      smallMachinesPoints.forEach(function(listenerJson) {
        this.push(new FacilityDetailsListenerViewModel(listenerJson));
      }, this.smallMachines);

      smallMachinesWashBoxPoints.forEach(function(listenerJson) {
        this.push(new FacilityDetailsListenerWashBoxViewModel(listenerJson));
      }, this.smallMachinesWashBoxes);
    }

    function refreshAlarms() {
      var that = this,
        messages = messagesStore.getMessages();

      this.messages = [];
      this.alarmsCount = 0;
      this.warningsCount = 0;

      if (messages !== null && messages.length > 0) {
        messages.forEach(function(messageJson) {
          if (messageJson.device === that.deviceSerial) {
            that.messages.push({
              //feedId: messageJson.feedId,
              deviceSerial: messageJson.device,
              collapseKey: messageJson.collapseKey,
              enableAlarmDismiss: enableAlarmDismiss(messageJson),
              timestamp: messageJson.timestamp,
              timeFormatted: moment(messageJson.timestamp).fromNow(),
              message: messageJson.content,
              alarmId: messageJson.id,
              deviceMoreInfo: messageJson.details,
              icon:
                messageJson.collapseKey === "alarm"
                  ? "assets/icons/ic_warning_black_24px.svg"
                  : "assets/icons/ic_info_outline_black_24px.svg"
            });
            messageJson.collapseKey === "alarm"
              ? (that.alarmsCount += 1)
              : (that.warningsCount += 1);
          }
        });
      }
    }

    function enableAlarmDismiss(messageData) {
      var alarmMessagesIncludeList = [
        'UNKNOWN_RESET',
        'SOFTWARE_RESET',
        'EXTERNAL_PIN_RESET',
        'RESTART_OR_BROWNOUT_OCCURRED',
        'DEAD_RM5_CHANNEL_PIN_ERROR',
        'COULD_NOT_SIMULATE_COIN',
        'ERROR_SETTING_INHIBIT_MODE',
        'CONNECTION_ERROR'
      ];
      return alarmMessagesIncludeList.includes(messageData.content) && messageData.collapseKey === 'alarm';
    }

    function getSubsystem(idsArray) {
      // This object (this.tapWaterSubsystemData) is empty if device type is Listener or HHanle type. In that case this check is necessary.
      if (
        idsArray.length == 2 ||
        Object.keys(this.tapWaterSubsystemData).length === 0
      ) {
        return this.facility;
      } else if (idsArray.length === 3) {
        var id = idsArray[2];
        if (this.tapWaterSubsystemData.pointId.toString() === id.toString()) {
          return this.tapWaterSubsystemData;
        } else if (
          this.softenedWaterSubsystemData.pointId.toString() === id.toString()
        ) {
          return this.softenedWaterSubsystemData;
        } else if (
          this.demiWaterSubsystemData.pointId.toString() === id.toString()
        ) {
          return this.demiWaterSubsystemData;
        } else if (
          this.reverseOsmosisSubsystemData.pointId.toString() === id.toString()
        ) {
          return this.reverseOsmosisSubsystemData;
        } else if (
          this.doserSubsystemData.pointId.toString() === id.toString()
        ) {
          return this.doserSubsystemData;
        } else {
          var box = this.boxes.find(function(boxViewModel) {
            return boxViewModel.pointId.toString() === id.toString();
          });
          return box ? box : null;
        }
      } else {
        return null;
      }
    }

    function updateConnectionStatus(id, data, list) {
      if (data.reference === "CONNECTION_ERROR") {
        list.map(function(listener) {
          if (listener.pointId === parseInt(id)) {
            data.currentValue === "0"
              ? (listener.listenerStatus = "online")
              : (listener.listenerStatus = "offline");
          }
        });
      }
      if (data.reference === "OP_BUTTON") {
        list.map(function(listener) {
          if (listener.pointId === parseInt(id)) {
            listener.hhanleDeviceStatus = data.value;
          }
        });
      }
      return list;
    }
  }
})();
